module.exports = "images/-16.1fa7fbd1.png";